import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import { ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await adminLogin(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Admin session started");
      nav("/admin/dashboard");
    } else {
      toast.error(r.error);
    }
  };

  return (
    <div className="min-h-screen">
      <Navbar variant="public" />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="soft-card p-8">
          <Logo variant="auth" testId="admin-login-logo" className="mb-6" />
          <div className="chip-light mb-3 mx-auto w-fit">
            <ShieldCheck className="w-3.5 h-3.5" /> Admin only
          </div>
          <h1 className="font-display text-3xl font-extrabold text-slate-900 text-center">Command center</h1>
          <p className="text-slate-500 mt-1 text-center">Restricted access to manage sessions & users.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label className="font-semibold text-slate-700">Admin email</Label>
              <Input data-testid="admin-login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 border border-slate-200 h-11" />
            </div>
            <div>
              <Label className="font-semibold text-slate-700">Password</Label>
              <Input data-testid="admin-login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 border border-slate-200 h-11" />
            </div>
            <Button type="submit" disabled={loading} data-testid="admin-login-submit-btn" className="w-full bg-brand hover:bg-brand-dark text-slate-900 font-bold h-11 rounded-full shadow-btn">
              {loading ? "Signing in…" : "Enter dashboard"}
            </Button>
          </form>

          <div className="mt-6 text-sm text-slate-500 text-center">
            Not an admin? <Link to="/login" className="font-semibold text-brand underline" data-testid="link-user-login">User sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
